import React, { Fragment } from 'react'
import CategoryItem from '../CategoryItem'
import SectionItem from '../SectionItem'
import { Draggable } from 'react-beautiful-dnd'

const NavList = ({ categories, parsedCategoryId, parsedSectionId, onOpenSidebar, onOpenDeleteModal, isCategoryOpen, onCategoryItemClick, onSectionItemClick }) => {
  return (
    <Fragment>
      {categories.map((category, i) => {
        return (
          <Draggable key={category.id} draggableId={`${category.id}`} index={i}>
            {(provided, snapshot) => {
              return (
                <Fragment>
                  <CategoryItem
                    provided={provided}
                    snapshot={snapshot}
                    onCategoryItemClick={onCategoryItemClick}
                    categories={categories}
                    category={category}
                    parsedCategoryId={parsedCategoryId}
                    onOpenSidebar={onOpenSidebar}
                    onOpenDeleteModal={onOpenDeleteModal}
                    shouldToggleChevron={category.id === parsedCategoryId && category.sections.length && !snapshot.isDragging}
                  />
                  <div className="section-items-list-wrapper">
                    {parsedCategoryId === category.id && !snapshot.isDragging &&
                      category.sections.map(section => {
                        return (
                          <SectionItem
                            key={section.id}
                            provided={provided}
                            snapshot={snapshot}
                            section={section}
                            category={category}
                            parsedSectionId={parsedSectionId}
                            onOpenSidebar={onOpenSidebar}
                            onOpenDeleteModal={onOpenDeleteModal}
                            onSectionItemClick={onSectionItemClick}
                          />
                        )
                    })}
                  </div>
                </Fragment>
              )
            }}
          </Draggable>
        )
      })}
    </Fragment>
  )
}

export default NavList
